import React, { Fragment, PureComponent, ReactNode, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Virtuoso } from 'react-virtuoso';
import { Patient, getPtFullNameWithSalutation } from '../store/types/patient';
import {
    amIDoctor,
    getDoctorSelectorList,
    getItemFromMisc,
    isDoctorSelectorPossible,
    getDoc,
    getMe,
    MISC_KEYS,
    upsertPatient,
    amIDoctorOnly,
    isSingleDoctorAccess,
    getMySingleDoctorId,
} from '../store/idbHandler';
import { connect, useDispatch, useSelector } from 'react-redux';
import { getAgeInYears, getAgeString } from '../store/utils';
import { APWithOptionalpatient, OptionItem } from './Appointments';
import { toLocalPatient, WithBEPatient } from '../store/actions/app';
import { AnimatePresence } from 'framer-motion';
import { GenieSettings, SREV2 } from '../api/pushGenie';
import { ABHA_IDS, CONTACT, FOLLOW_UP, LAST_VISITED, PT_DETAILS, UHID } from '../constants';
import fetchBookSlotHash, { Res } from '../api/fetchBookSlotHash';
import { toggleIframeActionDialog } from '../store/actions/session';
import { AbhaFilled, AbhaIconNotLinked, EkaCareIcon } from '../components/common/Icons';
import { AntTooltip } from '../components/common/AntTooltip';
import archivePatientAPI from '../api/archivePatient';
import { Dropdown, Menu, Modal, notification } from 'antd';
import MedicalCertificateDialog from '../components/common/MedicalCertificateDialog';
import { printLabelForPatient } from '../modules/barcode';
import { AddAddressBt } from '../components/prescriptionPad/rightPanel/finishScreen/AddAddressBt';
import { track } from '../tracking';
import { AttachmentInPd } from './AttachmentsInPd';
import {
    getAppointmentAction,
    getAppointmentActionTextForAction,
    onAddToQueue,
    START_VISIT,
} from './AppointmentUtils';
import { getSalutation, isOnboardedForLab, isOnboardedForPharma } from './utils';
import { AddRecordsBtV2 } from './MedicalRecordsRightPanel';
import LinkABHAV2 from './LinkAbhav2';
import { requestAbhaCreation } from '../api/abha/request-abha';
import { GlobalState } from '../store/reducers';
import { getGenieSetting } from '../store/selectors/session';
import { OrderMedicineDialog } from '../components/prescriptionPad/rightPanel/finishScreen/OrderMedicine';
import { getPincode } from '../components/prescriptionPad/rightPanel/finishScreen/OrderMedicineUtils';
import { BookLabTestsDialog } from '../components/prescriptionPad/rightPanel/finishScreen/BookLabTests';
import moment from 'moment';
import { ACTIVE_TAB } from './HEDashboard';
import PatientHealthSummaryPopoverIcon from '../components/common/PatientHealthSummary/PopoverIcon';
import AllInsightsModalVisible from '../components/common/PatientHealthSummary/AllInsightsModalVisible';
import { PatientHealthSummaryResponse } from '../api/getPatientHealthSummary';
import { getMyIdWithBackwardCompatibility } from '../api/mactiveid';
import { MyDoc } from '../api/fetchMyProfile';
import DoctorSelectorPopup from '../components/common/DoctorSelectorPopOver';
import { LANG_CODE_TO_NAME } from '../components/prescriptionPad/rightPanel/previewScreen/PreviewPanel';
import { getAccessControl, showAccessDeniedError } from '../store/AccessControl';
import AdmitPatientAllPtButton from '../components/IPD/AdmitPatientAllPtButton';
import { getAclViewClassName } from '../restrictions/utils';
import archivePatientInParchi from '../api/archivePatientInParchi';

type Props = {
    cId: string;
    patients: Patient[];
    columns: { key: string; label: string }[];
    todayAppointments: APWithOptionalpatient[];
    onPatientsDetails: (ptId: string) => void;
    tDate: string;
    startVisit: (docid: string, p: Patient) => void;
    onReferADoc: (p: Patient) => void;
    onCreateABHA: (p: Patient) => void;
    onSendReceipt: (docid: string, p: Patient) => void;
    onArchivePatient: () => void;
    onAppointmentAction: (ap: APWithOptionalpatient) => void;
    activeLinkAbhaPatient: Patient | undefined;
    setActiveLinkAbhaPatient: (patient?: Patient) => void;
    onAbhaLink: (pt: Patient) => void;
    onMultiDocBookApt: (props: MultiDocBookAptHandlerProps) => void;
    hidePatientHealthSummary?: boolean;
};

export type MultiDocBookAptHandlerProps = { docId: string; clinicId: string; ptId: string };

type State = {
    type?: string;
    patient?: Patient;
    patientHealthSummary?: PatientHealthSummaryResponse;
};

class AllPatientList extends PureComponent<Props, State> {
    state: State = {};
    // componentDidUpdate(prevProps: Props): void {
    //     // Log key which got change compare to previous state

    //     const changedKeyProps = Object.keys(this.props).filter(
    //         (key) => this.props[key as keyof Props] !== prevProps[key as keyof Props],
    //     );
    //     console.log("rendering all pt list State's key got changed :", changedKeyProps);
    // }

    toggleOrderCTAHandler = (type?: string, patient?: Patient): void => {
        if (type && patient) {
            this.setState({ type, patient });
            track('CLICK_QUICK_ORDER_BUTTON', { type });
        } else {
            this.setState({ type: undefined, patient: undefined });
        }
    };

    toggleAllInsightsModalVisible = (
        patientHealthSummary?: PatientHealthSummaryResponse,
        patient?: Patient,
    ): void => {
        if (patientHealthSummary) {
            this.setState({
                patientHealthSummary,
                patient,
            });
        } else {
            this.setState({
                patientHealthSummary: undefined,
                patient: undefined,
            });
        }
    };

    docs = getMe()?.docs;

    renderPtRow = (i: number, p: Patient): JSX.Element => {
        // console.log('rendering all pt pt', p.personal.name);
        const {
            columns,
            todayAppointments,
            activeLinkAbhaPatient,
            setActiveLinkAbhaPatient,
            hidePatientHealthSummary,
            cId,
        } = this.props;
        const { toggleAllInsightsModalVisible, toggleOrderCTAHandler } = this;
        const apptIndex = todayAppointments
            ? todayAppointments.findIndex((a) => a.patient_oid === p.id)
            : -1;
        const referredDoctor = p?.formData?.find((data) => data.key === 'referredby');
        const patientId = p.id || p.localId || '';
        const patientName = p?.personal?.name?.f.trim() || '';

        return (
            <div
                key={`${p.localId}-${apptIndex}`}
                className="hover-parent-element py-10 flex flex-1 h-full items-center w-full text-13 border-b border-neutral-8 justify-between"
            >
                <div className="flex items-center justify-center w-40 px-8 ">
                    <p>{i + 1}</p>
                </div>
                {columns.map((c) => {
                    switch (c.key) {
                        case PT_DETAILS:
                            return (
                                <div
                                    onClick={() => this.props.onPatientsDetails(p.localId)}
                                    className="flex items-center space-x-4 text-left cursor-pointer px-8 hover-parent-element"
                                    style={{ width: 280 }}
                                    id={p.id || p.localId || ''}
                                >
                                    <div className="w-16 h-16 flex items-center justify-center">
                                        {p.abha?.id && (
                                            <AntTooltip placement="bottom" content={p.abha?.id}>
                                                {AbhaIconNotLinked}
                                            </AntTooltip>
                                        )}
                                    </div>
                                    <p className="text-14 capitalize">
                                        <span className="text-actionPrimary select-all">
                                            {getPtFullNameWithSalutation(p)}
                                        </span>
                                        <span>
                                            {p.personal.gender && ', '}
                                            {p.personal.gender}
                                            {getAgeString(
                                                {
                                                    age: p.personal.age?.value,
                                                    month: p.personal.age?.month,
                                                    dob: p.personal.age?.dob,
                                                },
                                                ', ',
                                            )}
                                            {referredDoctor ? (
                                                <AntTooltip
                                                    content={
                                                        <span>
                                                            Referred by{' '}
                                                            {[referredDoctor?.value]
                                                                .filter(Boolean)
                                                                .join(' ')}
                                                        </span>
                                                    }
                                                >
                                                    <span>
                                                        {p?.referredBy && (
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="14"
                                                                height="14"
                                                                viewBox="0 0 14 14"
                                                                fill="#004BA8"
                                                                className="inline-block ml-8 cursor-default"
                                                            >
                                                                <path
                                                                    d="M7 12.4062C8.87891 12.4062 10.6055 11.416 11.5703 9.76562C12.5098 8.14062 12.5098 6.13477 11.5703 4.48438C10.6055 2.85938 8.87891 1.84375 7 1.84375C5.0957 1.84375 3.36914 2.85938 2.4043 4.48438C1.46484 6.13477 1.46484 8.14062 2.4043 9.76562C3.36914 11.416 5.0957 12.4062 7 12.4062ZM7 0.625C9.31055 0.625 11.4434 1.86914 12.6113 3.875C13.7793 5.90625 13.7793 8.36914 12.6113 10.375C11.4434 12.4062 9.31055 13.625 7 13.625C4.66406 13.625 2.53125 12.4062 1.36328 10.375C0.195312 8.36914 0.195312 5.90625 1.36328 3.875C2.53125 1.86914 4.66406 0.625 7 0.625ZM9.4375 8.59766C9.4375 8.90234 9.1582 9.15625 8.85352 9.15625C8.70117 9.15625 8.54883 9.10547 8.44727 9.00391L7.60938 8.14062L5.9082 9.8418C5.83203 9.91797 5.70508 9.96875 5.57812 9.96875C5.42578 9.96875 5.32422 9.91797 5.22266 9.8418L4.2832 8.90234C4.20703 8.80078 4.15625 8.69922 4.15625 8.54688C4.15625 8.41992 4.20703 8.29297 4.2832 8.2168L5.98438 6.51562L5.12109 5.67773C5.01953 5.57617 4.96875 5.42383 4.96875 5.27148C4.96875 4.9668 5.22266 4.6875 5.52734 4.6875H9.03125C9.23438 4.6875 9.4375 4.89062 9.4375 5.09375V8.59766Z"
                                                                    fill="#004BA8"
                                                                ></path>
                                                            </svg>
                                                        )}
                                                    </span>
                                                </AntTooltip>
                                            ) : (
                                                <span>
                                                    {p?.referredBy && (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="14"
                                                            height="14"
                                                            viewBox="0 0 14 14"
                                                            fill="#004BA8"
                                                            className="inline-block ml-8 cursor-default"
                                                        >
                                                            <path
                                                                d="M7 12.4062C8.87891 12.4062 10.6055 11.416 11.5703 9.76562C12.5098 8.14062 12.5098 6.13477 11.5703 4.48438C10.6055 2.85938 8.87891 1.84375 7 1.84375C5.0957 1.84375 3.36914 2.85938 2.4043 4.48438C1.46484 6.13477 1.46484 8.14062 2.4043 9.76562C3.36914 11.416 5.0957 12.4062 7 12.4062ZM7 0.625C9.31055 0.625 11.4434 1.86914 12.6113 3.875C13.7793 5.90625 13.7793 8.36914 12.6113 10.375C11.4434 12.4062 9.31055 13.625 7 13.625C4.66406 13.625 2.53125 12.4062 1.36328 10.375C0.195312 8.36914 0.195312 5.90625 1.36328 3.875C2.53125 1.86914 4.66406 0.625 7 0.625ZM9.4375 8.59766C9.4375 8.90234 9.1582 9.15625 8.85352 9.15625C8.70117 9.15625 8.54883 9.10547 8.44727 9.00391L7.60938 8.14062L5.9082 9.8418C5.83203 9.91797 5.70508 9.96875 5.57812 9.96875C5.42578 9.96875 5.32422 9.91797 5.22266 9.8418L4.2832 8.90234C4.20703 8.80078 4.15625 8.69922 4.15625 8.54688C4.15625 8.41992 4.20703 8.29297 4.2832 8.2168L5.98438 6.51562L5.12109 5.67773C5.01953 5.57617 4.96875 5.42383 4.96875 5.27148C4.96875 4.9668 5.22266 4.6875 5.52734 4.6875H9.03125C9.23438 4.6875 9.4375 4.89062 9.4375 5.09375V8.59766Z"
                                                                fill="#004BA8"
                                                            ></path>
                                                        </svg>
                                                    )}
                                                </span>
                                            )}
                                        </span>
                                    </p>
                                    {!hidePatientHealthSummary && (
                                        <PatientHealthSummaryPopoverIcon
                                            patientId={patientId}
                                            patientName={patientName}
                                            toggleAllInsightsModalVisible={(patientHealthSummary) =>
                                                toggleAllInsightsModalVisible(
                                                    patientHealthSummary,
                                                    p,
                                                )
                                            }
                                        />
                                    )}
                                </div>
                            );
                        case CONTACT:
                            return (
                                <div
                                    style={{ width: 130 }}
                                    className={`text-left select-all px-8 ${getAclViewClassName(
                                        SREV2.PATIENT_MOBILE_NUMBER,
                                    )}`}
                                >
                                    <p>
                                        {p.personal.phone?.c}
                                        {p.personal.phone?.n}
                                    </p>
                                </div>
                            );
                        case LAST_VISITED:
                            return (
                                <div style={{ width: 130 }} className=" text-left px-8">
                                    <p>
                                        {p.lastVisitedAt
                                            ? moment(p.lastVisitedAt).format('ddd MMM DD `YY')
                                            : '-'}
                                    </p>
                                </div>
                            );
                        case FOLLOW_UP:
                            return (
                                <div style={{ width: 130 }} className=" text-left px-8">
                                    {p.followUpDate?.toDateString() === this.props.tDate ? (
                                        <span
                                            className="text-status-info bg-status-infoBG py-4 px-24 rounded-4 inline-flex items-center select-none text-14"
                                            title={this.props.tDate}
                                        >
                                            Today
                                        </span>
                                    ) : p.followUpDate ? (
                                        moment(p.followUpDate).format('ddd MMM DD `YY')
                                    ) : (
                                        '-'
                                    )}
                                </div>
                            );
                        case UHID:
                            return (
                                <div style={{ width: 100 }} className="break-all text-left px-8">
                                    <p>
                                        {p.formData?.find((fd) => fd.key === c.key)?.value || '-'}
                                    </p>
                                </div>
                            );
                        case ABHA_IDS:
                            return (
                                <div className="break-all text-left px-8 flex-shrink-0">
                                    <LinkABHAV2
                                        key={cId + p.localId}
                                        patient={p}
                                        cId={cId}
                                        isAbhaModalOpen={
                                            p?.id == activeLinkAbhaPatient?.id ? true : false
                                        }
                                        setIsAbhaModel={(isOpen) => {
                                            setActiveLinkAbhaPatient(isOpen ? p : undefined);
                                        }}
                                        abhaIdCss="text-darwin-neutral-800"
                                        onAbhaLink={this.props.onAbhaLink}
                                    />
                                </div>
                            );
                        default:
                            return (
                                <div style={{ width: 130 }} className=" text-left px-8">
                                    <p>{getFormDataValue(p, c) || '-'}</p>
                                </div>
                            );
                    }
                })}

                <div className="w-15p pl-8 py-1">
                    <div className="w-full h-full flex justify-end relative items-center">
                        {todayAppointments && apptIndex > -1 && todayAppointments[apptIndex] ? (
                            <div
                                onClick={() =>
                                    this.props.onAppointmentAction(todayAppointments[apptIndex])
                                }
                                className="whitespace-nowrap p-4 inline-flex items-center space-x-4 cursor-pointer justify-end rounded-4 relative tooltip-wrapper"
                            >
                                {getAppointmentActionTextForAction(
                                    getAppointmentAction(todayAppointments[apptIndex]),
                                )}
                                {getAppointmentAction(todayAppointments[apptIndex]) ===
                                    START_VISIT && (
                                    <div className="tooltip-tip left">Patient in Queue</div>
                                )}
                            </div>
                        ) : (
                            <DoctorSelectorPopup
                                onSelect={(doc) =>
                                    this.props.startVisit(doc?.id || getDoc()?._id || '', p)
                                }
                                clinicId={cId}
                            >
                                <button
                                    // onClick={() =>
                                    //     // p.lastGoingVisit
                                    //     // ? this.navigateToVisit(p.lastGoingVisit) :
                                    //     this.props.startVisit(getDoc()?._id || '', p)
                                    // }
                                    className="whitespace-nowrap border-b border-transparent cursor-pointer text-actionPrimary hover:text-actionPrimary-hover hover:border-actionPrimary-hover font-700 focus:outline-none"
                                >
                                    {/* {p.lastGoingVisit ? (
                                <p className="font-700 text-status-success">Ongoing</p>
                            ) : ( */}
                                    Start Visit
                                    {/* )} */}
                                </button>
                            </DoctorSelectorPopup>
                        )}

                        <Options
                            p={p}
                            onReferADoc={this.props.onReferADoc}
                            onCreateABHA={this.props.onCreateABHA}
                            onSendReceipt={this.props.onSendReceipt}
                            onArchivePatient={this.props.onArchivePatient}
                            toggleOrderCTAHandler={toggleOrderCTAHandler}
                            onMultiDocBookApt={this.props.onMultiDocBookApt}
                        />
                    </div>
                </div>
            </div>
        );
    };

    render(): ReactNode {
        const { patients } = this.props;
        const { type, patient, patientHealthSummary } = this.state;
        const { toggleOrderCTAHandler, toggleAllInsightsModalVisible } = this;
        const ageObj = patient?.personal.age || {};
        const age = getAgeInYears(ageObj) || 18;
        const formData = patient?.formData || [];
        const patientId = patient?.id || patient?.localId || '';
        const patientName = patient?.personal?.name?.f.trim() || '';
        const name = [patient?.personal.name.f, patient?.personal.name.l].filter(Boolean).join(' ');
        const phone = patient?.personal.phone?.n || '';
        const gender = patient?.personal.gender || '';

        return (
            <Fragment>
                <Virtuoso
                    style={{ width: '100%' }}
                    totalCount={patients.length}
                    data={patients}
                    itemContent={this.renderPtRow}
                    computeItemKey={(index, item) => item.id || item.localId}
                    overscan={1000}
                />
                <AnimatePresence>
                    {type === ACTIVE_TAB.MEDS && patient && (
                        <OrderMedicineDialog
                            closeMe={toggleOrderCTAHandler}
                            formData={formData}
                            pxid={''}
                            patientId={patientId}
                            name={name}
                            phone={phone}
                            gender={gender}
                            age={age}
                            clinicPin={getPincode(patient)}
                            isForQuickCart
                            patient={patient}
                            showGoToHEDashboardButton
                        />
                    )}
                    {type === ACTIVE_TAB.LABS && patient && (
                        <BookLabTestsDialog
                            closeMe={toggleOrderCTAHandler}
                            formData={formData}
                            pxid={''}
                            patientid={patientId}
                            name={name}
                            phone={phone}
                            gender={gender}
                            age={age}
                            isForQuickCart
                            patient={patient}
                            showGoToHEDashboardButton
                        />
                    )}
                </AnimatePresence>

                <AllInsightsModalVisible
                    isVisible={Boolean(patientHealthSummary)}
                    closeMe={toggleAllInsightsModalVisible}
                    patientId={patientId}
                    patientName={patientName}
                    patientHealthSummary={patientHealthSummary as PatientHealthSummaryResponse}
                    from="all-pt-insights-modal"
                />
            </Fragment>
        );
    }
}

const Options: React.FC<{
    p: Patient;
    onReferADoc: (p: Patient) => void;
    onCreateABHA: (p: Patient) => void;
    onSendReceipt: (docid: string, p: Patient) => void;
    onArchivePatient: () => void;
    toggleOrderCTAHandler: (type?: string, patient?: Patient) => void;
    onMultiDocBookApt: (props: MultiDocBookAptHandlerProps) => void;
}> = ({
    p,
    onReferADoc,
    onCreateABHA,
    onSendReceipt,
    onArchivePatient,
    toggleOrderCTAHandler,
    onMultiDocBookApt,
}) => {
    const [isAddingToQueue, setIsAddingToQueue] = useState(false);
    const [isArchivingPatient, setIsArchivingPatient] = useState(false);
    const params: { cId: string } = useParams();
    const dispatch = useDispatch();
    const [isMedicalCertificate, setIsMedicalCertificate] = useState<string | undefined>();
    const [isBarcodeEnabled, setIsBarcodeEnabled] = useState(false);
    const [blockArchievePatient, setblockArchievePatient] = useState(false);
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const isAbdm = useSelector((state: GlobalState) => getGenieSetting(state, 'abdm'));
    const doctorSelectorList = getDoctorSelectorList();

    useEffect(() => {
        getItemFromMisc<GenieSettings>(
            getMyIdWithBackwardCompatibility() || '',
            MISC_KEYS.settings,
        ).then((res) => {
            setIsBarcodeEnabled(res.barcodeEnabled);
        });
    }, []);

    const archivePatient = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
        setblockArchievePatient(true);
        Modal.confirm({
            title: `This patient ${p.personal.name.f} will be removed from your directory & you won't be able to see their data.`,
            okText: 'Confirm',
            okButtonProps: { className: 'primary-btn font-lato' },
            cancelButtonProps: { className: 'neutral-btn font-lato' },
            onOk: () => {
                setblockArchievePatient(false);
                setIsArchivingPatient(false);
                WithBEPatient<Patient>(
                    p,
                    async (bePt: Patient) => bePt,
                )(dispatch)
                    .then(async (bePt) => {
                        if (bePt) {
                            await Promise.all([
                                archivePatientAPI(bePt.id || bePt.localId),
                                archivePatientInParchi(bePt.id || bePt.localId),
                            ]);
                            await upsertPatient({ ...bePt, archived: true });
                            onArchivePatient();
                        } else {
                            track('ERROR', {
                                on: 'archivPatient',
                                what: 'could not find patient by id',
                            });
                            alert('Failed to archive patient');
                        }
                    })
                    .catch((e) => {
                        track('ERROR', { on: 'archivPatient', what: 'idk', error: e.message });
                        alert('Failed to archive patient');
                    });
            },
            onCancel: () => {
                setblockArchievePatient(false);
            },
            cancelText: 'Cancel',
        });
    };

    const onBookAppointment = (doc?: MyDoc) => {
        WithBEPatient<void>(p, async (bePt) => {
            const myProfile = getMe();
            const { id: docId = myProfile?.docs?.[0]?.id || myProfile?.doctor?._id } = doc || {};
            const clinicId = params.cId;

            onMultiDocBookApt({ clinicId, docId: docId!, ptId: bePt.id });
        })(dispatch).catch(() => {
            alert('Failed to book slot');
        });
    };

    const printLabel = () => {
        track('Print_label', { from: 'All_pt' });
        printLabelForPatient(p);
    };

    const optionItemCallback = (callback: (doc?: MyDoc) => void, doc?: MyDoc) => () => {
        closeDropdown();
        callback(doc);
    };

    const referADoc = () => onReferADoc(p);
    const createABHA = () => onCreateABHA(p);
    const sendReciept = (docid?: string) => onSendReceipt(docid || getDoc()?._id || '', p);
    const showMedCert = (doc?: MyDoc) => setIsMedicalCertificate(doc?.id || getMySingleDoctorId());

    const archivePtCallback = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (blockArchievePatient) {
            return;
        }

        const archiveCallback = () => archivePatient(e);
        optionItemCallback(archiveCallback)();
    };

    const addToQueueCallback = (doc?: MyDoc) => (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    ) => {
        const addToQueueCallback = () =>
            onAddToQueue(
                e,
                p,
                params.cId,
                () => null,
                (val: boolean) => setIsAddingToQueue(val),
                doc,
            );
        optionItemCallback(addToQueueCallback)();
    };

    const closeDropdown = () => setIsDropdownVisible(false);

    const requestAbha = () => {
        if (p?.id) {
            track('REQUEST_ABHA_CLICKED', { from: 'options-dropdown' });

            requestAbhaCreation(
                p.id,
                () =>
                    notification.success({
                        message: 'ABHA creation request sent successfully!',
                        duration: 5,
                    }),
                () =>
                    notification.error({
                        message: 'Something went wrong!',
                        duration: 5,
                    }),
            );
        } else {
            track('REQUEST_ABHA_DISMISSED', { ptId: p.id, from: 'options-dropdown' });
        }
    };

    const menu = (
        <Menu>
            {/* {isDoctorSelectorPossible() ? (
                <Menu.SubMenu
                    className="normal-submenu"
                    title={
                        <div className="flex justify-between py-8 px-4 text-neutral-2 font-600 cursor-pointer">
                            <div>
                                <p>{'Book Appointment'}</p>
                            </div>
                            <svg
                                width="25"
                                height="25"
                                viewBox="0 0 28 28"
                                className={`fill-neutral-5 cursor-pointer`}
                                preserveAspectRatio="xMidYMid meet"
                            >
                                <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                            </svg>
                        </div>
                    }
                >
                    {doctorSelectorList.map((doc) => (
                        <OptionItem
                            onClick={optionItemCallback(onBookAppointment, doc)}
                            label={[doc.personal.name.f, doc.personal.name.l]
                                .filter(Boolean)
                                .join(' ')}
                            key={'book-appointment' + doc.id}
                        />
                    ))}
                </Menu.SubMenu>
            ) : (
                <OptionItem
                    onClick={optionItemCallback(onBookAppointment)}
                    label={'Book Appointment'}
                    key="book-appointment"
                />
            )} */}

            <AdmitPatientAllPtButton patient={p} closeDropdown={closeDropdown} />

            {isDoctorSelectorPossible() ? (
                <Menu.SubMenu
                    className="normal-submenu"
                    title={
                        <div className="flex justify-between py-8 px-4 text-neutral-2 font-600 cursor-pointer">
                            <div>
                                <p>{'Book Appointment'}</p>
                            </div>
                            <svg
                                width="25"
                                height="25"
                                viewBox="0 0 28 28"
                                className={`fill-neutral-5 cursor-pointer`}
                                preserveAspectRatio="xMidYMid meet"
                            >
                                <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                            </svg>
                        </div>
                    }
                >
                    {doctorSelectorList.map((doc) => (
                        <OptionItem
                            onClick={() => onBookAppointment(doc)}
                            label={[doc.personal.name.f, doc.personal.name.l]
                                .filter(Boolean)
                                .join(' ')}
                            key={'book_apt' + doc.id}
                            isLoading={isAddingToQueue}
                        />
                    ))}
                </Menu.SubMenu>
            ) : (
                <OptionItem
                    onClick={optionItemCallback(onBookAppointment)}
                    label={'Book Appointment'}
                    key="book-appointment"
                />
            )}

            {isDoctorSelectorPossible() ? (
                <Menu.SubMenu
                    className="normal-submenu"
                    title={
                        <div className="flex justify-between py-8 px-4 text-neutral-2 font-600 cursor-pointer">
                            <div>
                                <p>{'Add to Queue'}</p>
                            </div>
                            <svg
                                width="25"
                                height="25"
                                viewBox="0 0 28 28"
                                className={`fill-neutral-5 cursor-pointer`}
                                preserveAspectRatio="xMidYMid meet"
                            >
                                <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                            </svg>
                        </div>
                    }
                >
                    {doctorSelectorList.map((doc) => (
                        <OptionItem
                            onClick={isAddingToQueue ? () => undefined : addToQueueCallback(doc)}
                            label={[doc.personal.name.f, doc.personal.name.l]
                                .filter(Boolean)
                                .join(' ')}
                            key={'Add to Queue' + doc.id}
                            isLoading={isAddingToQueue}
                        />
                    ))}
                </Menu.SubMenu>
            ) : (
                <OptionItem
                    onClick={
                        isAddingToQueue
                            ? () => undefined
                            : addToQueueCallback(doctorSelectorList[0])
                    }
                    label={'Add to Queue'}
                    isLoading={isAddingToQueue}
                />
            )}

            {/* {isAbdm && !p.abha?.id && (
                <OptionItem
                    onClick={optionItemCallback(requestAbha)}
                    label={'Request ABHA creation'}
                    subLabel="Send ABHA creation link to patient"
                />
            )} */}

            {!p.abha?.id && (
                <OptionItem onClick={optionItemCallback(createABHA)} label={'Create ABHA'} />
            )}

            {amIDoctorOnly() && (
                <OptionItem
                    onClick={optionItemCallback(referADoc)}
                    label={'Refer to Doctor'}
                    className={getAclViewClassName(SREV2.REFER_PATIENT_TO_DOCTOR)}
                />
            )}

            {isDoctorSelectorPossible() ? (
                <Menu.SubMenu
                    className="normal-submenu"
                    title={
                        <div className="flex justify-between py-8 px-4 text-neutral-2 font-600 cursor-pointer">
                            <div>
                                <p>{'Bill Patient'}</p>
                            </div>
                            <svg
                                width="25"
                                height="25"
                                viewBox="0 0 28 28"
                                className={`fill-neutral-5 cursor-pointer`}
                                preserveAspectRatio="xMidYMid meet"
                            >
                                <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                            </svg>
                        </div>
                    }
                >
                    {doctorSelectorList.map((doc) => (
                        <OptionItem
                            onClick={optionItemCallback(() => {
                                const canCreateReceipt = getAccessControl().isAccessAvailable(
                                    SREV2.CAN_CREATE_RECEIPT_WITH_APT,
                                );
                                canCreateReceipt ? sendReciept(doc.id) : showAccessDeniedError();
                            })}
                            label={[doc.personal.name.f, doc.personal.name.l]
                                .filter(Boolean)
                                .join(' ')}
                            className={getAclViewClassName(SREV2.CAN_CREATE_RECEIPT_WITH_APT)}
                        />
                    ))}
                </Menu.SubMenu>
            ) : (
                <OptionItem
                    onClick={optionItemCallback(() => {
                        const doctor_oid = getMySingleDoctorId();
                        const canCreateReceipt = getAccessControl().isAccessAvailable(
                            SREV2.CAN_CREATE_RECEIPT_WITH_APT,
                        );
                        canCreateReceipt ? sendReciept(doctor_oid) : showAccessDeniedError();
                    })}
                    label={'Bill Patient'}
                    subLabel={'+ Add to Queue'}
                    className={getAclViewClassName(SREV2.CAN_CREATE_RECEIPT_WITH_APT)}
                />
            )}

            <Menu.Item className={getAclViewClassName(SREV2.UPLOAD_MEDICAL_RECORDS)}>
                <div className="flex items-center justify-between text-neutral-2 px-4">
                    <AddRecordsBtV2
                        ptId={p.localId}
                        text="Add Medical Records"
                        cssClass="flex cursor-pointer items-center w-full font-600 text-14 py-12 rounded-4"
                        cssClassInner="flex h-full justify-between w-full items-center cursor-pointer"
                        from="all-patients"
                        showArrow={true}
                        closeDropdown={closeDropdown}
                    />
                </div>
            </Menu.Item>

            {isDoctorSelectorPossible() ? (
                <Menu.SubMenu
                    className="normal-submenu"
                    title={
                        <div className="flex justify-between py-8 px-4 text-neutral-2 font-600 cursor-pointer">
                            <div>
                                <p>{'Create Medical document'}</p>
                                <p className="text-10 text-neutral-1 opacity-50">
                                    {'medical certificate, consent form etc.'}
                                </p>
                            </div>
                            <svg
                                width="25"
                                height="25"
                                viewBox="0 0 28 28"
                                className={`fill-neutral-5 cursor-pointer`}
                                preserveAspectRatio="xMidYMid meet"
                            >
                                <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                            </svg>
                        </div>
                    }
                >
                    {doctorSelectorList.map((doc) => (
                        <OptionItem
                            onClick={optionItemCallback(showMedCert, doc)}
                            label={[doc.personal.name.f, doc.personal.name.l]
                                .filter(Boolean)
                                .join(' ')}
                            className={getAclViewClassName(SREV2.CAN_CREATE_RECEIPT_WITH_APT)}
                        />
                    ))}
                </Menu.SubMenu>
            ) : (
                <OptionItem
                    onClick={optionItemCallback(showMedCert)}
                    label={'Create Medical document'}
                    subLabel="medical certificate, consent form etc."
                    className={getAclViewClassName(SREV2.CREATE_MEDICAL_DOCUMENTS)}
                />
            )}

            {amIDoctor() && (
                <AttachmentInPd
                    html={
                        <Menu.Item
                            className="font-lato"
                            style={{
                                background: 'linear-gradient(136deg, #FFF8E8 0%, #F8E3AF 100%)',
                            }}
                        >
                            <div className="flex justify-between py-8 px-4 text-neutral-2 font-600 cursor-pointer">
                                <div>
                                    <p>Send Attachment</p>
                                </div>

                                <svg
                                    width="25"
                                    height="25"
                                    viewBox="0 0 28 28"
                                    className="fill-neutral-5"
                                    preserveAspectRatio="xMidYMid meet"
                                >
                                    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                                </svg>
                            </div>
                        </Menu.Item>
                    }
                    patient={p}
                    closeDropdown={closeDropdown}
                />
            )}
            {isSingleDoctorAccess() && (isOnboardedForPharma() || isOnboardedForLab()) && (
                <AddAddressBt
                    html={
                        <Menu.Item className="font-lato">
                            <div className="flex justify-between py-8 px-4 text-neutral-2 font-600 cursor-pointer">
                                <div>
                                    <p>Add Address</p>
                                </div>

                                <svg
                                    width="25"
                                    height="25"
                                    viewBox="0 0 28 28"
                                    className="fill-neutral-5"
                                    preserveAspectRatio="xMidYMid meet"
                                >
                                    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                                </svg>
                            </div>
                        </Menu.Item>
                    }
                    patient={p}
                    closeDropdown={closeDropdown}
                />
            )}
            {isBarcodeEnabled && <OptionItem onClick={printLabel} label={'Print Label'} />}
            {/* {isSingleDoctorAccess() && (
                <OptionItem
                    onClick={() => {
                        toggleOrderCTAHandler(ACTIVE_TAB.MEDS, p);
                        onVisibleChange(false);
                    }}
                    label={'Order Medicines'}
                    className={getAclViewClassName(SREV2.HXNG_ORDERS)}
                />
            )} */}
            {isSingleDoctorAccess() && (
                <OptionItem
                    onClick={() => {
                        toggleOrderCTAHandler(ACTIVE_TAB.LABS, p);
                        onVisibleChange(false);
                    }}
                    label={'Book Lab Tests'}
                    className={getAclViewClassName(SREV2.HXNG_ORDERS)}
                />
            )}
            <OptionItem
                onClick={archivePtCallback}
                label={'Archive Patient'}
                isLoading={isArchivingPatient}
                labelClassName="text-status-warning"
                rightIconFill="fill-status-warning"
                className={getAclViewClassName(SREV2.PATIENT_DATABASE)}
            />
        </Menu>
    );

    const onVisibleChange = (prev: boolean) => {
        setIsDropdownVisible(prev);
    };

    return (
        <Fragment>
            <AnimatePresence>
                {isMedicalCertificate && (
                    <MedicalCertificateDialog
                        patient={p}
                        closeMe={() => setIsMedicalCertificate(undefined)}
                        docid={isMedicalCertificate}
                    />
                )}
            </AnimatePresence>
            <Dropdown
                onVisibleChange={onVisibleChange}
                visible={isDropdownVisible}
                overlay={menu}
                placement="bottomRight"
                trigger={['click']}
                arrow={true}
                overlayClassName="z-50"
            >
                <div>
                    <svg
                        width="25"
                        height="25"
                        viewBox="0 0 28 28"
                        className="fill-neutral-5 cursor-pointer"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z"></path>
                    </svg>
                </div>
            </Dropdown>
        </Fragment>
    );
};

export default connect((state: GlobalState) => ({
    hidePatientHealthSummary: getGenieSetting(state, 'hidePatientHealthSummary') as boolean,
}))(AllPatientList);

function getFormDataValue(p: Patient, c: { key: string; label: string }): React.ReactNode {
    const value = p.formData?.find((fd) => fd.key === c.key)?.value;
    if (c.key === 'lang') {
        return LANG_CODE_TO_NAME[value as string] || value;
    }

    return value;
}
